import { render, staticRenderFns } from "./eventDetail.vue?vue&type=template&id=022fe9fd&scoped=true"
import script from "./eventDetail.vue?vue&type=script&lang=ts"
export * from "./eventDetail.vue?vue&type=script&lang=ts"
import style0 from "./eventDetail.vue?vue&type=style&index=0&id=022fe9fd&prod&lang=scss"
import style1 from "./eventDetail.vue?vue&type=style&index=1&id=022fe9fd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022fe9fd",
  null
  
)

export default component.exports